import { Layout } from 'antd'
import APIDataTitlePage from './title';
import AppOrDeveloperChartPage from './AppOrdeveloperChart';
import QuantityChartPage from './quantityChart';
import QartQuantityChartPage from './qartQuantityChart';
const APIDataNoticfication = () => {
    return(
        <Layout.Content >
        <APIDataTitlePage />
        <AppOrDeveloperChartPage/>
        <QuantityChartPage/>
        <QartQuantityChartPage/>
    </Layout.Content>
    )
    
}

export default APIDataNoticfication